import React from 'react';
import { NumericInput, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import { ValueRangeModel } from "../../models/index.js";
const {
  t
} = ns('ui-attributes-graphs.editors.ValueRangeEditor');
export default function ValueRangeEditor(props) {
  const {
    value
  } = props;
  const onValueRangeModelChange = useValueChange(ValueRangeModel, props);
  const onChange = e => {
    const {
      data,
      value: nValue
    } = e;
    onValueRangeModelChange({
      data,
      value: nValue
    });
  };
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "xyChartEditor"
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('name'),
    stretch: true
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: value?.name,
    eventData: "setName",
    onChange: onChange,
    hint: t('rangeLabelHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('minimum')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: value?.min,
    eventData: "setMin",
    onChange: onChange,
    float: true,
    changeOnBlur: true,
    hint: t('rangeMinimumHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('maximum')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: value?.max,
    eventData: "setMax",
    onChange: onChange,
    changeOnBlur: true,
    float: true,
    min: value?.min ? value.min + 1 : null,
    hint: t('rangeMaximumHint')
  })), /*#__PURE__*/React.createElement(PropertyGrid.Divider, null));
}